import { EnvironmentKey, getEnvironmentConfig } from '@choco-admin/utils';
import React from 'react';

interface EnvironmentItemProps {
  environment: EnvironmentKey;
  isSelected: boolean;
  onSelect: (env: EnvironmentKey) => void;
}

export const EnvironmentItem: React.FC<EnvironmentItemProps> = ({
  environment,
  isSelected,
  onSelect,
}) => {
  const config = getEnvironmentConfig(environment);

  const handleClick = () => {
    onSelect(environment);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onSelect(environment);
    }
  };

  return (
    <div
      className={`p-3 px-6 cursor-pointer transition-colors border-none bg-transparent w-full text-left hover:bg-default-50 focus:outline-none focus:bg-default-100 ${
        isSelected
          ? 'bg-primary-50 hover:bg-primary-100 focus:bg-primary-100'
          : ''
      }`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-pressed={isSelected}
      aria-label={`Select ${config.name} environment`}
    >
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center">
          <div
            className={`w-4 h-4 border-2 rounded-full bg-white transition-all relative ${
              isSelected ? 'border-primary' : 'border-default-300'
            }`}
          >
            {isSelected && (
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full bg-primary" />
            )}
          </div>
        </div>

        <div className="flex items-center justify-center w-8 h-8">
          <span className="text-xl leading-none">{config.emoji}</span>
        </div>

        <div className="flex-1 min-w-0">
          <div className="text-sm font-medium text-foreground mb-0.5">
            {config.name}
          </div>
          <div className="text-xs text-foreground-500 font-mono">
            {environment}
          </div>
        </div>
      </div>
    </div>
  );
};
